import { useEffect, useRef } from 'react';

import { type BaseApiStore } from './BaseApiStore';

let index = 0;

export function useAttach(
  store: InstanceType<typeof BaseApiStore>,
  name = 'x',
  { isDisabled }: { isDisabled?: boolean } = {},
) {
  const instanceRef = useRef<string | null>(null);

  if (instanceRef.current === null) {
    instanceRef.current = `${store.key}:${name}:${index++}`;
  }

  useEffect(() => {
    const ref = instanceRef;

    if (store && isDisabled !== true) {
      store.attach(ref.current);
      return function () {
        store.detach(ref.current);
      };
    }
  }, [store, isDisabled]);
}
